<template>
  <div>

    <div v-if="$route.path.indexOf('_editor') === -1">
      <el-card>
        <el-alert
                title="优惠券活动说明"
                type="info"
                description="默认生成的活动分享码不关联推广店铺，如果要指定推广店铺请点击指定店铺活动码选择下载."
                show-icon>
        </el-alert>
      </el-card>
      <el-row :gutter="20">

        <el-col :md="8" :lg="5">
          <el-input placeholder="优惠券活动列" v-model="params.name" clearable><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
        </el-col>
        <el-col :span="3" class="content-right">
          <el-button type="primary" icon="plus" @click="handleAdd">添加活动</el-button>
        </el-col>
      </el-row>

      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="优惠券活动列" name="admin"></el-tab-pane>
        <el-table :data="list" :height="wheight-160" v-loading="loading">
          <el-table-column prop="id" label="id"></el-table-column>
          <el-table-column prop="name" label="活动名"></el-table-column>
          <el-table-column prop="activity_time" label="活动时间"></el-table-column>
          <el-table-column prop="banner" label="图片">
            <template slot-scope="scope">
              <el-popover
                      placement="right"
                      width="240"
                      trigger="hover" >
                <img  :src="wximageurl + scope.row.banner" style="width:100%;">
                <el-button type="text" slot="reference"><img src="/static/img/icon_img.png" ></el-button>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column prop="activity_barcode" label="活动分享码(无店铺关系)">
            <template slot-scope="scope">
              <el-popover
                      placement="right"
                      width="240"
                      trigger="hover" >
                <img  :src="wximageurl + scope.row.activity_barcode" style="width:100%;">
                <el-button type="text" slot="reference"><img src="/static/img/icon_img.png" ></el-button>
              </el-popover>
            </template>
          </el-table-column>


          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="operating-icons">
                <i class="iconfont icon-edit1" @click="handleEditDistribution(scope.row)"></i>
                <el-button type="primary" size="mini" @click="downloadQRcode(scope.row)">指定店铺活动码</el-button>
                <!--<el-button type="primary" size="mini" @click="handleCopyDistribution(scope.row)">复制活动</el-button>-->
                <br>
              </div>
            </template>
          </el-table-column>
        </el-table>

          <el-dialog title="指定店铺活动码" :visible.sync="distributor_dialog" :close-on-click-modal="false">
              <el-form v-model="distributor_from" label-width="160px">
                  <el-form-item label="活动名称">
                      <el-input :disabled="true" v-model="distributor_from.name"  ></el-input>
                  </el-form-item>
                  <el-form-item label="作用门店">
                      <el-tag :key="item.distributor_id" class="new-tag" v-for="(item,index) in relDistributors" closable :disable-transitions="false" @close="handleClose(index)"> {{item.name}}
                      </el-tag>
                      <el-button size="medium" class="button-new-tag" @click="addDistributoreAction">+ 点击搜索店铺 </el-button>
                  </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer content-center">
                  <el-button type="primary" @click="handleDistributionSave" :disabled="clickable" >确定</el-button>
              </div>
          </el-dialog>
          <DistributorSelect :store-visible="DistributorVisible" :is-valid="isValid" :rel-data-ids="relDistributors" :get-status="DistributorStatus" @chooseStore="DistributorChooseAction" @closeStoreDialog="closeDialogAction"></DistributorSelect>

      </el-tabs>


      <div class="content-padded content-center">
        <el-pagination background
                       layout="prev, pager, next, total"
                       @current-change="handleCurrentChange"
                       :current-page.sync="params.page"
                       :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import {getCouponActivity,downLoadCouponActivityQrcodes} from '../../../api/cardticket'
    // import DistributorSelect from '@/components/function/distributorSelect'
    import DistributorSelect from '@/components/storeListSelect'
    import imgPicker from '@/components/imageselect'
    export default {
        components: {
            imgPicker,
            DistributorSelect,
        },
        data () {
            return {
                distributor_from:{
                    id:'',
                    name:'',
                    distributor_ids:[],
                    distributor_list:[],
                },
                clickable:false,
                dialog: false,
                distributor_dialog:false,
                relDistributors:[],
                DistributorVisible: false,
                DistributorStatus: false,
                isValid: true,
                activeName: 'admin',
                list: [],
                total_count: 0,
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    name:'',
                },
                DistributorName:'',
                mode: 'richText',
                picsDialog: false,
                imgDialog: false,
                isGetImage: false,
                imgIndex: 0,
                cardList: [],
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            handleSizeChange (pageSize) {
                this.fetchParams.currentPage = 1
                this.fetchParams.pageSize = pageSize
                this.getCardList()
            },
            handleClose(index) {
                this.relDistributors.splice(index, 1);
                this.distributor_from.distributor_ids.splice(index, 1);
            },
            DistributorChooseAction (data) {
                this.DistributorVisible = false
                this.DistributorStatus = false
                if (data === null || data.length <= 0) return
                this.relDistributors = data
                this.distributor_from.distributor_list = data
            },
            closeDialogAction () {
                this.DistributorStatus = false
                this.DistributorVisible = false
            },
            handleAdd () {
                this.$router.push({path:'/marketing/coupon/coupon_activity/coupon_activity_editor'})
            },
            addDistributoreAction() {
                this.DistributorVisible = true
                this.DistributorStatus = true
            },
            handleEditDistribution(row)
            {
                this.$router.push({path:'/marketing/coupon/coupon_activity/coupon_activity_editor/'+row.id})
            },
            handleCopyDistribution(row){
                this.$router.push({path:'/marketing/coupon/coupon_activity/coupon_activity_editor/?copyid='+row.id})
            },
            handleLog(row){
                this.$router.push({path:'/store/storemanager/distributor_selfActivity_log',query:{activity_id:row.id}})
            },
            handleDistributionSave(){
                // console.log(this.distributor_from)
                downLoadCouponActivityQrcodes(this.distributor_from).then(res =>{
                    var temp = ''
                    var arr = res.data.data
                    arr.forEach(function(item){
                        var a = document.createElement('a')
                        a.href = item.qrcode_url
                        a.download = item.name + ".png"
                        a.click()
                    })
                })
            },
            handleCurrentChange (val) {
                this.currentPage = val
                this.loading = false
                this.params.page = val
                this.getList()
            },
            numberSearch () {
                this.params.page = 1
                this.getList()
            },
            // 下载指定店铺活动码
            downloadQRcode(row){
                this.clearDistributor_form()
                this.distributor_dialog = true
                this.distributor_from.name = row.name
                this.distributor_from.id = row.id
            },
            clearDistributor_form(){
                this.distributor_from.id = ''
                this.distributor_from.name = ''
                this.distributor_from.distributor_ids = []
                this.distributor_from.distributor_list = []
                this.relDistributors = []
            },
            getList () {
                this.loading = true
                getCouponActivity(this.params).then(response => {
                    if(response.data.data.list) {
                        // console.log(response.data.data.list)
                        this.list = response.data.data.list
                        this.total_count = Number(response.data.data.total_count)

                    }
                    this.loading = false
                })
            },
            handleImgPicker () {
                this.imgDialog = true
                this.isGetImage = true
            },
            pickImg (data) {
                this.form.image = data.url
                this.imgDialog = false
            },
            closeImgDialog () {
                this.imgDialog = false
                this.isGetImage = false
            },
        },
        mounted () {
            this.getList()
        },
        watch:{
            '$route':'getList'
        }
    }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vue-html5-editor {
    vertical-align: top;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// couponActivity.vue?4da53d82